export default (key, metadata) =>
  metadata && metadata.__notConfigured__ ? key : App.Text.get2(key)
